export const languageData = [
    { id: 2, language: 'Hebrew', locale: 'he', flag: 'flag:il' },
    { id: 1, language: 'English', locale: 'en', flag: 'flag:us' },
    { id: 3, language: 'Arabic', locale: 'ar', flag: 'flag:arab' },
    { id: 4, language: 'Russian', locale: 'ru', flag: 'flag:ru' },
];
